import React, { useState } from "react";
import { Link, Stack } from "@mui/material";
import { CLAMP_LENGTH, CLAMP_LINES, REVIEW_COPY } from "./reviewChanges.consts";
import { CellText } from "./ReviewChangesDialog.styles";

// Long text is clamped to a few lines with a "Show more" toggle. `children` may replace `text`
// for display (e.g. highlighted diff segments) while `text` decides whether it is long.
const ClampedText = ({ text, children, muted = false }) => {
  const [expanded, setExpanded] = useState(false);
  const isLong = (text?.length ?? 0) > CLAMP_LENGTH || (text?.split("\n").length ?? 0) > CLAMP_LINES;
  const toggle = (event) => {
    event.stopPropagation();
    setExpanded((value) => !value);
  };
  return (
    <Stack alignItems="flex-start" gap={0.5}>
      <CellText clamped={isLong && !expanded} muted={muted}>{children ?? text}</CellText>
      {isLong && (
        <Link component="button" type="button" variant="caption" underline="hover" onClick={toggle}>
          {expanded ? REVIEW_COPY.SHOW_LESS : REVIEW_COPY.SHOW_MORE}
        </Link>
      )}
    </Stack>
  );
};

export default ClampedText;
